module.exports = __webpack_public_path__ + "img/1CD3C1640F601A84C856DC3D3062D96D.1cd3c164.png";